@if (user) {
  <div
    class="video-bubble-container presentation-bubble"
    #videoBubble
    [ngClass]="{
      'presentation-bubble-border': !visualIndicators,
    }"
    [ngStyle]="{
      'background-color': !visualIndicators
        ? 'var(--primary-color)'
        : presentationV3
          ? 'rgba(5, 14, 37, 0.25)'
          : 'transparent',
    }"
    (mouseenter)="onMouseEnter(videoBubble)"
    (mouseleave)="onMouseOut(videoBubble)"
  >
    <div class="avatar-wrapper">
      <profile-picture [user]="user" [borderWidth]="'0'" [size]="size" [responsive]="true"></profile-picture>
    </div>
    <div class="user-video" [ngStyle]="{ border: visualIndicators ? ringBorder : 'none' }">
      <video
        [id]="videoElementId"
        [ngClass]="{
          localUser: isLocal,
          disabled:
            !videoEnabled ||
            isPresenting ||
            videoLoading ||
            isUserSpeakingInGallery ||
            (videoElement.readyState || 0) < 4,
        }"
        #videoElement
        [muted]="true"
      ></video>
    </div>
    <!-- Presentation State for Video Bubble -->
    <div>
      <!-- Reaction emote -->
      @if (emote) {
        <div class="bubble-emote">
          <span class="emote-text">{{ emote.native }}</span>
        </div>
      }
      <!-- Audio Off -->
      @if (!audioEnabled) {
        <div class="presentation-circle-indicator flex justify-center items-center">
          @if (isLocal) {
            <mat-icon class="circle-indicator-icon">mic_off</mat-icon>
          }
          @if (!isLocal) {
            <mat-icon class="circle-indicator-icon">volume_off</mat-icon>
          }
        </div>
      }
      <!-- Favoriting -->
      @if (((showMediaState && !isUserSpeakingInGallery) || isFavorite) && !isLocal) {
        <div
          class="presentation-favoriting-indicator flex justify-center items-center"
          (click)="addOrRemoveFavorites()"
        >
          @if (isFavorite) {
            <mat-icon class="circle-indicator-icon">star</mat-icon>
          }
          @if (!isFavorite) {
            <mat-icon class="circle-indicator-icon">star_outline</mat-icon>
          }
        </div>
      }
      <!-- Camera Off -->
      @if ((!videoEnabled && showMediaState && !isUserSpeakingInGallery) || (videoElement?.readyState || 0) < 4) {
        <div class="presentation-media-indicators-wrapper flex justify-center items-center">
          <mat-icon class="media-indicator">videocam_off</mat-icon>
        </div>
      }
      <!-- Badge -->
      @if (showMediaState) {
        <div class="presentation-badge-indicator flex justify-center items-center" (click)="openBadge()">
          <span class="name-text">
            {{ nameTag }}
          </span>
          <span><mat-icon class="badge-icon">info</mat-icon></span>
        </div>
      }
      <!-- Speaking Overlay -->
      @if (isUserSpeakingInGallery) {
        <div class="presentation-media-indicators-wrapper flex justify-center items-center">
          <mat-icon>mic</mat-icon>
        </div>
      }
      <!-- Speaking Animation -->
      @if (showAnimation) {
        <div class="presentation-sound-wave">
          <div class="box box1"></div>
          <div class="box box2"></div>
          <div class="box box3"></div>
        </div>
      }
    </div>
  </div>
}
